import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import r from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectDestructuringEmpty.js";
import i from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/extends.js";
import "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import * as s from "@radix-ui/react-dialog";
//#region src/components/primitives/dialog.tsx
var c = ["className"], l = [
	"className",
	"children",
	"showCloseButton"
], u = ["className"], d = ["className"], f = ["className"], p = ["className"];
function m(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(s.Root, n({ "data-slot": "dialog" }, t));
}
function h(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(s.Trigger, n({ "data-slot": "dialog-trigger" }, t));
}
function g(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(s.Portal, n({ "data-slot": "dialog-portal" }, t));
}
function _(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(s.Close, n({ "data-slot": "dialog-close" }, t));
}
function v(r) {
	let { className: i } = r, o = t(r, c);
	return /* @__PURE__ */ a(s.Overlay, n({
		"data-slot": "dialog-overlay",
		className: e("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", i)
	}, o));
}
function y(r) {
	let { className: i, children: c, showCloseButton: u = !0 } = r, d = t(r, l);
	return /* @__PURE__ */ o(g, {
		"data-slot": "dialog-portal",
		children: [/* @__PURE__ */ a(v, {}), /* @__PURE__ */ o(s.Content, n(n({
			"data-slot": "dialog-content",
			className: e("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200", i)
		}, d), {}, { children: [c, u && /* @__PURE__ */ o(s.Close, {
			"data-slot": "dialog-close",
			className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=size-])]:size-4",
			children: [/* @__PURE__ */ a("i", { className: "fa-regular fa-x" }), /* @__PURE__ */ a("span", {
				className: "sr-only",
				children: "Close"
			})]
		})] }))]
	});
}
function b(r) {
	let { className: i } = r, o = t(r, u);
	return /* @__PURE__ */ a("div", n({
		"data-slot": "dialog-header",
		className: e("flex flex-col gap-2 text-center sm:text-left", i)
	}, o));
}
function x(r) {
	let { className: i } = r, o = t(r, d);
	return /* @__PURE__ */ a("div", n({
		"data-slot": "dialog-footer",
		className: e("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", i)
	}, o));
}
function S(r) {
	let { className: i } = r, o = t(r, f);
	return /* @__PURE__ */ a(s.Title, n({
		"data-slot": "dialog-title",
		className: e("text-lg leading-none font-semibold", i)
	}, o));
}
function C(r) {
	let { className: i } = r, o = t(r, p);
	return /* @__PURE__ */ a(s.Description, n({
		"data-slot": "dialog-description",
		className: e("text-muted-foreground text-sm", i)
	}, o));
}
//#endregion
export { m as Dialog, _ as DialogClose, y as DialogContent, C as DialogDescription, x as DialogFooter, b as DialogHeader, v as DialogOverlay, g as DialogPortal, S as DialogTitle, h as DialogTrigger };

//# sourceMappingURL=dialog.js.map